import { render, staticRenderFns } from "./cardUser.vue?vue&type=template&id=0093d7ed&lang=pug&"
import script from "./cardUser.vue?vue&type=script&lang=ts&"
export * from "./cardUser.vue?vue&type=script&lang=ts&"
import style0 from "./cardUser.vue?vue&type=style&index=0&lang=stylus&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports